// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__Gu47C","icon":"style_icon__c4dd6","title":"style_title__2d6ve","logo":"style_logo__Zlwx9","logoContainer":"style_logoContainer__2zSCn"};